/**
 * Validation utilities and patterns for form validation
 */

/**
 * This string version regular expression is used to validate user input by only allowing the user to enter Full numbers including negative ones
 * */
export const intNumberPattern = '^-?[0-9]*$';

/**
 * This string version regular expression is used to validate user input by only allowing the user to enter a number of maximum length of 10
 * */
export const maxNumberLengthPattern = '^.{0,10}$';

/**
 * This string version regular expression is used to validate user input by only allowing the user to enter:
 * Full numbers, Double numbers, Empty string, Negative Full or Double numbers,
 * Does not allow any type of letters or special character,
 * Does not allow the number to start with "." eg ".47".
 * */
export const doubleNumberPattern = '^(?:$|-?\\d*(?:\\.\\d*)?|\\.\\d+)$';

/**
 * Allows only positive integers greater than or equal to 1.
 */
export const positiveIntMinOnePattern = '^(?:[1-9]|[1-9][0-9]*)?$';

/**
 * Allows integers between 1 and 28 inclusive.
 */
export const positiveIntOneToTwentyEightPattern = '^(?:[1-9]|1\\d|2[0-8])?$';

/**
 * Allows integers between 1 and 30 inclusive.
 */
export const positiveIntOneToThirtyPattern = '^(?:[1-9]|[1-2][0-9]|30)$';

/**
 * Allows non-negative integers (including 0).
 */
export const nonNegativeIntPattern = '^(?:[0-9]|[1-9][0-9]*)?$';

/**
 * Allows integers from 0 up to 23 inclusive.
 */
export const positiveIntZeroToTwentyThreePattern = '^(?:[0-9]|1\\d|2[0-3])?$';

/**
 * Try to parse a string value to integer
 * @param value string value to parse
 * @param result number to store the result
 * @returns boolean indicating if parsing was successful
 */
export const tryParseInt = (value: string, result: number) => {
  result = parseInt(value);
  return !isNaN(result);
};

/**
 * Check if text content is truncated in an element
 * @param elementId the ID of the element to check
 * @returns boolean indicating if text is truncated
 */
export const isTextTruncated = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    return element.scrollWidth > element.clientWidth;
  }
  return false;
};
